import isDineInApplicationVariant from 'bento-ordering/utils/isDineInApplicationVariant';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import {
  HonestPricingLawServiceFeeTypes,
  HONEST_PRICING_LAW_SERVICE_FEE_NAMES
} from 'base-ordering/constants/HonestPricingLaw';
import { getHonestLawCustomFeeText } from 'base-ordering/utils/getHonestLawCustomFeeText';
import { getHonestLawServiceFeeText } from 'base-ordering/utils/getHonestLawServiceFeeText';

/**
 *
 * @param {str} onlineOrderingFulfillmentMethod
 * @param {bool} isGroupOrder
 * @param {str} displayServiceFee
 * @param {bool} chargeCustomFee
 * @param {str} customFeeAmount
 * @param {str} customFeeFlatOrPercent
 * @param {str} customFeeName
 * }
 *
 * Used to help render the Honest Pricing Law fees for our various
 * OO commerce types (online-ordering, group-ordering, dine-in ordering)
 * @returns {{
 * feeType: str,
 * bannerFeeText: str,
 * cartItemizedHelperText: str
 * }}
 */
export const mapCartToServiceFeeType = (
  displayServiceFee,
  onlineOrderingFulfillmentMethod,
  isGroupOrder,
  chargeCustomFee = false,
  chargeServiceFee = false,
  customFeeName = '',
  customFeeAmount = '',
  customFeeFlatOrPercent = ''
) => {
  const isDineInVariant = isDineInApplicationVariant();

  let feeType = '';

  if (
    isDineInVariant ||
    onlineOrderingFulfillmentMethod === fulfillmentOptions.DINE_IN
  ) {
    feeType = HonestPricingLawServiceFeeTypes.DINE_IN_ORDER;
  } else if (isGroupOrder) {
    feeType = HonestPricingLawServiceFeeTypes.GROUP_ORDER;
  } else {
    feeType = HonestPricingLawServiceFeeTypes.ONLINE_ORDER;
  }

  const bannerText = getHonestLawServiceFeeText(
    chargeServiceFee,
    displayServiceFee,
    feeType
  );

  const bannerFeeText = getHonestLawCustomFeeText(
    bannerText,
    chargeCustomFee,
    chargeServiceFee,
    feeType,
    customFeeName,
    customFeeAmount,
    customFeeFlatOrPercent
  );

  const cartItemizedHelperText = `The ${displayServiceFee} ${HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType]} helps to cover the cost associated with access to the technology used to place this order online.`;

  return {
    feeType: HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType],
    bannerFeeText,
    cartItemizedHelperText
  };
};
